import React from "react"
import { EditEventForm } from "../../../components/EditEventForm"

export const EditEventPage = () => {
  return (
    <div>
      <EditEventForm />
    </div>
  )
}
